(function () {
  'use strict';

  function openEnquiryPopup(button) {
    var popupId = button.getAttribute('data-product-enquiry-open');

    if (!popupId) {
      console.warn('Enquiry popup ID is missing.');
      return;
    }

    var popup = document.getElementById(popupId);

    if (!popup) {
      console.warn('Enquiry popup not found:', popupId);
      return;
    }

    /*
     * Move popup outside the theme content wrapper.
     */
    if (popup.parentNode !== document.body) {
      document.body.appendChild(popup);
    }

    popup.removeAttribute('hidden');
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');

    button.setAttribute('aria-expanded', 'true');

    document.body.classList.add(
      'product-enquiry-popup-open'
    );

    var dialog = popup.querySelector(
      '.product-enquiry-popup__dialog'
    );

    if (dialog) {
      window.requestAnimationFrame(function () {
        dialog.focus();
      });
    }
  }

  function closeEnquiryPopup(popup) {
    if (!popup) {
      return;
    }

    popup.hidden = true;
    popup.setAttribute('hidden', '');
    popup.setAttribute('aria-hidden', 'true');

    document.body.classList.remove(
      'product-enquiry-popup-open'
    );

    var popupId = popup.getAttribute('id');

    if (popupId) {
      var trigger = document.querySelector(
        '[data-product-enquiry-open="' + popupId + '"]'
      );

      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }
    }
  }

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest(
      '[data-product-enquiry-open]'
    );

    if (openButton) {
      event.preventDefault();
      openEnquiryPopup(openButton);
      return;
    }

    var closeButton = event.target.closest(
      '[data-product-enquiry-close]'
    );

    if (closeButton) {
      event.preventDefault();

      var popup = closeButton.closest(
        '[data-product-enquiry-popup]'
      );

      closeEnquiryPopup(popup);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') {
      return;
    }

    var openPopup = document.querySelector(
      '[data-product-enquiry-popup]:not([hidden])'
    );

    closeEnquiryPopup(openPopup);
  });
})();